"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var _require = require("../../../../../../config/constants"),
  APPLE_PAY = _require.APPLE_PAY,
  GOOGLE_PAY = _require.GOOGLE_PAY,
  PAY_WITH_GOOGLE = _require.PAY_WITH_GOOGLE,
  PAYPAL = _require.PAYPAL;
var _require2 = require("../../commons/index"),
  getExpressPaymentMethods = _require2.getExpressPaymentMethods,
  calculateProductPrice = _require2.calculateProductPrice;
var _require3 = require("../../commons/httpClient"),
  httpClient = _require3.httpClient;
var _require4 = require("../paymentMethods"),
  ApplePay = _require4.ApplePay,
  GooglePay = _require4.GooglePay,
  Paypal = _require4.Paypal;
function findCurrentProductIdFromDom() {
  var _document$querySelect, _document$querySelect2;
  var pidFromAttr = (_document$querySelect = document.querySelector("[data-pid]")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.getAttribute("data-pid");
  if (pidFromAttr) return pidFromAttr;
  return (_document$querySelect2 = document.querySelector("#selected-express-product")) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.getAttribute("data-pid");
}
function buildFallbackProduct() {
  var id = findCurrentProductIdFromDom();
  var readyToOrderData = $(".global-availability").data("ready-to-order");
  var availableData = $(".global-availability").data("available");
  return {
    id: id,
    readyToOrder: readyToOrderData !== undefined ? readyToOrderData : true,
    available: availableData !== undefined ? availableData : true
  };
}
function fetchInitialProductVariation(_x) {
  return _fetchInitialProductVariation.apply(this, arguments);
}
function _fetchInitialProductVariation() {
  _fetchInitialProductVariation = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(dataUrl) {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.abrupt("return", httpClient({
            url: dataUrl,
            method: "GET"
          }));
        case 1:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _fetchInitialProductVariation.apply(this, arguments);
}
function renderInitialExpress(_x2) {
  return _renderInitialExpress.apply(this, arguments);
}
function _renderInitialExpress() {
  _renderInitialExpress = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(paymentMethodsResponse) {
    var dataUrl, productVariation, fallbackProduct;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          $.spinner().start();
          dataUrl = $(".quantity-select").find("option:selected").data("url");
          if (!dataUrl) {
            _context5.next = 10;
            break;
          }
          _context5.next = 5;
          return fetchInitialProductVariation(dataUrl);
        case 5:
          productVariation = _context5.sent;
          if (!(productVariation !== null && productVariation !== void 0 && productVariation.product)) {
            _context5.next = 10;
            break;
          }
          $("body").trigger("product:renderExpressPaymentContainer", {
            product: productVariation.product,
            paymentMethodsResponse: paymentMethodsResponse
          });
          $.spinner().stop();
          return _context5.abrupt("return");
        case 10:
          fallbackProduct = buildFallbackProduct();
          if (fallbackProduct.id) {
            $("body").trigger("product:renderExpressPaymentContainer", {
              product: fallbackProduct,
              paymentMethodsResponse: paymentMethodsResponse
            });
          }
          $.spinner().stop();
        case 13:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _renderInitialExpress.apply(this, arguments);
}
function getProductForm(product) {
  var $productInputEl = document.createElement("input");
  $productInputEl.setAttribute("id", "selected-express-product");
  $productInputEl.setAttribute("name", "selected-express-product");
  $productInputEl.setAttribute("type", "hidden");
  $productInputEl.setAttribute("data-pid", "".concat(product.id));
  $productInputEl.setAttribute("data-basketId", "");
  $productInputEl.value = JSON.stringify(product);
  var $productForm = document.createElement("form");
  $productForm.setAttribute("id", "express-product-form");
  $productForm.setAttribute("name", "express-product-form");
  $productForm.append($productInputEl);
  return $productForm;
}
function getPaymentMethodConfig(adyenPaymentMethods, paymentMethodType) {
  var _adyenPaymentMethods$;
  return adyenPaymentMethods === null || adyenPaymentMethods === void 0 ? void 0 : (_adyenPaymentMethods$ = adyenPaymentMethods.paymentMethods.find(function (pm) {
    return paymentMethodType.indexOf(pm.type) > -1;
  })) === null || _adyenPaymentMethods$ === void 0 ? void 0 : _adyenPaymentMethods$.configuration;
}
function getProductPrice(_x3) {
  return _getProductPrice.apply(this, arguments);
}
function _getProductPrice() {
  _getProductPrice = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(productId) {
    var quantity,
      response,
      _args6 = arguments;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          quantity = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : 1;
          _context6.next = 3;
          return calculateProductPrice(productId, quantity);
        case 3:
          response = _context6.sent;
          if (!response.success) {
            _context6.next = 6;
            break;
          }
          return _context6.abrupt("return", {
            value: Math.round(response.totalAmount.value * 100),
            // Convert to minor units (cents)
            currency: response.totalAmount.currencyCode
          });
        case 6:
          return _context6.abrupt("return", null);
        case 7:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _getProductPrice.apply(this, arguments);
}
function getProductId() {
  var _document$querySelect3, _document$querySelect4;
  return ((_document$querySelect3 = document.querySelector("[data-pid]")) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.getAttribute("data-pid")) || ((_document$querySelect4 = document.querySelector("#selected-express-product")) === null || _document$querySelect4 === void 0 ? void 0 : _document$querySelect4.getAttribute("data-pid"));
}
function getProductQuantity() {
  var _document$querySelect5, _document$querySelect6;
  return ((_document$querySelect5 = document.querySelector('[name="Quantity"]')) === null || _document$querySelect5 === void 0 ? void 0 : _document$querySelect5.value) || ((_document$querySelect6 = document.querySelector(".quantity-select")) === null || _document$querySelect6 === void 0 ? void 0 : _document$querySelect6.value) || 1;
}
function calculateInitialAmount(_x4) {
  return _calculateInitialAmount.apply(this, arguments);
}
function _calculateInitialAmount() {
  _calculateInitialAmount = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(currency) {
    var productId, quantity, initialAmount, productPrice;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          productId = getProductId();
          quantity = getProductQuantity();
          initialAmount = {
            value: 0,
            currency: currency
          };
          if (!productId) {
            _context7.next = 8;
            break;
          }
          _context7.next = 6;
          return getProductPrice(productId, quantity);
        case 6:
          productPrice = _context7.sent;
          if (productPrice) {
            initialAmount.value = productPrice.value;
          }
        case 8:
          return _context7.abrupt("return", initialAmount);
        case 9:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _calculateInitialAmount.apply(this, arguments);
}
function renderApplePayButton() {
  $("body").on("product:render".concat(APPLE_PAY, "Button"), /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(e, response) {
      var _response$paymentMeth, _response$paymentMeth2, AdyenPaymentMethods, applicationInfo, adyenTranslations, currency, button, applePayConfig, initialAmount, applePay, applePayComponent;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _response$paymentMeth = response.paymentMethodsResponse, _response$paymentMeth2 = _response$paymentMeth === void 0 ? {} : _response$paymentMeth, AdyenPaymentMethods = _response$paymentMeth2.AdyenPaymentMethods, applicationInfo = _response$paymentMeth2.applicationInfo, adyenTranslations = _response$paymentMeth2.adyenTranslations, currency = _response$paymentMeth2.amount.currency, button = response.button;
            applePayConfig = getPaymentMethodConfig(AdyenPaymentMethods, APPLE_PAY);
            if (applePayConfig) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return");
          case 4:
            _context.next = 6;
            return calculateInitialAmount(currency);
          case 6:
            initialAmount = _context.sent;
            applePay = new ApplePay(applePayConfig, applicationInfo, adyenTranslations, true, initialAmount);
            _context.next = 10;
            return applePay.getComponent();
          case 10:
            applePayComponent = _context.sent;
            applePayComponent.mount(button);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x5, _x6) {
      return _ref.apply(this, arguments);
    };
  }());
}
function renderGooglePayButton() {
  $("body").on("product:render".concat(GOOGLE_PAY, "Button"), /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e, response) {
      var _response$paymentMeth3, _response$paymentMeth4, AdyenPaymentMethods, applicationInfo, adyenTranslations, currency, button, googlePayConfig, initialAmount, googlePay, googlePayComponent;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _response$paymentMeth3 = response.paymentMethodsResponse, _response$paymentMeth4 = _response$paymentMeth3 === void 0 ? {} : _response$paymentMeth3, AdyenPaymentMethods = _response$paymentMeth4.AdyenPaymentMethods, applicationInfo = _response$paymentMeth4.applicationInfo, adyenTranslations = _response$paymentMeth4.adyenTranslations, currency = _response$paymentMeth4.amount.currency, button = response.button;
            googlePayConfig = getPaymentMethodConfig(AdyenPaymentMethods, [GOOGLE_PAY, PAY_WITH_GOOGLE]);
            if (googlePayConfig) {
              _context2.next = 4;
              break;
            }
            return _context2.abrupt("return");
          case 4:
            initialAmount = {
              value: 0,
              currency: currency
            };
            googlePay = new GooglePay(googlePayConfig, applicationInfo, adyenTranslations, true, initialAmount);
            _context2.next = 8;
            return googlePay.getComponent();
          case 8:
            googlePayComponent = _context2.sent;
            googlePayComponent.mount(button);
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x7, _x8) {
      return _ref2.apply(this, arguments);
    };
  }());
}
function renderPaypalButton() {
  $("body").on("product:render".concat(PAYPAL, "Button"), /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(e, response) {
      var _response$paymentMeth5, _response$paymentMeth6, AdyenPaymentMethods, applicationInfo, adyenTranslations, currency, button, paypalConfig, initialAmount, paypal, paypalComponent;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _response$paymentMeth5 = response.paymentMethodsResponse, _response$paymentMeth6 = _response$paymentMeth5 === void 0 ? {} : _response$paymentMeth5, AdyenPaymentMethods = _response$paymentMeth6.AdyenPaymentMethods, applicationInfo = _response$paymentMeth6.applicationInfo, adyenTranslations = _response$paymentMeth6.adyenTranslations, currency = _response$paymentMeth6.amount.currency, button = response.button;
            paypalConfig = getPaymentMethodConfig(AdyenPaymentMethods, PAYPAL);
            if (paypalConfig) {
              _context3.next = 4;
              break;
            }
            return _context3.abrupt("return");
          case 4:
            _context3.next = 6;
            return calculateInitialAmount(currency);
          case 6:
            initialAmount = _context3.sent;
            paypal = new Paypal(paypalConfig, applicationInfo, adyenTranslations, true, initialAmount);
            _context3.next = 10;
            return paypal.getComponent();
          case 10:
            paypalComponent = _context3.sent;
            paypalComponent.mount(button);
          case 12:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x9, _x0) {
      return _ref3.apply(this, arguments);
    };
  }());
}
function getExpressPaymentButtons(paymentMethodsResponse, product) {
  var pdpExpressMethods = paymentMethodsResponse.pdpExpressMethods;
  return pdpExpressMethods.map(function (pm) {
    var $container = document.createElement("div");
    $container.setAttribute("id", "".concat(pm, "-pdp"));
    $container.setAttribute("class", "expressComponent ".concat(pm));
    $container.setAttribute("data-method", "".concat(pm));
    $container.setAttribute("data-pid", "".concat(product.id));
    $container.setAttribute("style", "padding:0");
    return $container;
  });
}
function renderExpressPaymentContainer() {
  $("body").on("product:renderExpressPaymentContainer", function (e, response) {
    var _paymentMethodsRespon;
    var _response$product = response.product,
      product = _response$product === void 0 ? {} : _response$product,
      paymentMethodsResponse = response.paymentMethodsResponse;
    var $expressPaymentButtonsContainer = document.getElementById("express-payment-buttons");
    if (product.readyToOrder && product.available && paymentMethodsResponse !== null && paymentMethodsResponse !== void 0 && (_paymentMethodsRespon = paymentMethodsResponse.pdpExpressMethods) !== null && _paymentMethodsRespon !== void 0 && _paymentMethodsRespon.length) {
      var expressPaymentButtons = getExpressPaymentButtons(paymentMethodsResponse, product);
      var $productForm = getProductForm(product);
      $expressPaymentButtonsContainer.replaceChildren.apply($expressPaymentButtonsContainer, _toConsumableArray(expressPaymentButtons).concat([$productForm]));
      expressPaymentButtons.forEach(function (button) {
        var expressType = button.getAttribute("data-method");
        $("body").trigger("product:render".concat(expressType, "Button"), {
          paymentMethodsResponse: paymentMethodsResponse,
          button: button
        });
      });
    } else {
      $expressPaymentButtonsContainer.replaceChildren();
    }
  });
}
function init() {
  return _init.apply(this, arguments);
}
function _init() {
  _init = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
    var paymentMethodsResponse;
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          if (!(window.areExpressPaymentsEnabledOnPdp === "true")) {
            _context9.next = 6;
            break;
          }
          _context9.next = 3;
          return getExpressPaymentMethods();
        case 3:
          paymentMethodsResponse = _context9.sent;
          $("body").on("product:updateAddToCart", function (e, response) {
            $("body").trigger("product:renderExpressPaymentContainer", {
              product: response.product,
              paymentMethodsResponse: paymentMethodsResponse
            });
          });
          $(document).ready(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
            return _regeneratorRuntime().wrap(function _callee8$(_context8) {
              while (1) switch (_context8.prev = _context8.next) {
                case 0:
                  _context8.next = 2;
                  return renderInitialExpress(paymentMethodsResponse);
                case 2:
                case "end":
                  return _context8.stop();
              }
            }, _callee8);
          })));
        case 6:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _init.apply(this, arguments);
}
module.exports = {
  init: init,
  renderExpressPaymentContainer: renderExpressPaymentContainer,
  renderApplePayButton: renderApplePayButton,
  renderGooglePayButton: renderGooglePayButton,
  renderPaypalButton: renderPaypalButton
};